export const DEFAULT_INSTRUMENT_SEARCH_QUERY = "ni";
export const MIN_INSTRUMENT_SEARCH_LENGTH = 3;

export const mapInstrumentSearchResults = (response = {}) => {
  const rows = Array.isArray(response?.data) ? response.data : [];

  return rows.map((item, index) => {
    const symbol = item.exchange_trading_symbol || item.symbol || "";
    const exchange = item.exchange || "";

    return {
      id: `${exchange}-${symbol}-${index}`,
      symbol,
      exchange,
      exchange_token: item.exchange_token ?? item.exchangeToken ?? null,
      exchangeTradingSymbol: symbol,
      description: exchange,
    };
  });
};
